import type { ButtonPropView } from '@consta/uikit/Button'
import { Button } from '@consta/uikit/Button'
import type { ReactNode } from 'react'
import { useMemo } from 'react'

import { preventDefaultHandle } from '../../../utils'
import { FormattedTooltipContent } from '../../FormattedTooltipContent'
import { TooltipTarget } from '../../TooltipTarget'
import type { ToolContainer, ToolVariant, ToolVariantProps } from '../types'
import { isToolActive } from './helpers'

type CardToolProps<T extends string> = ToolVariantProps<
  T,
  Exclude<ToolVariant<T>, ToolContainer<T>>
>

export function CardTool<T extends string>({ tool, activeTools, onToolChanged }: CardToolProps<T>) {
  const view = useMemo((): ButtonPropView => {
    if (isToolActive(activeTools, tool)) return 'primary'

    return tool.disabled ? 'ghost' : 'clear'
  }, [activeTools, tool])

  const content = (
    <FormattedTooltipContent title={tool.title} description={tool.description} />
  ) as ReactNode & string

  return (
    <TooltipTarget tooltipProps={{ content }}>
      <Button
        data-testid={tool.toolId}
        size="s"
        view={view}
        onlyIcon={true}
        iconLeft={tool.icon}
        disabled={tool.disabled}
        onClick={() => {
          onToolChanged(tool)
        }}
        onContextMenu={preventDefaultHandle}
      />
    </TooltipTarget>
  )
}
